import React from 'react';
import clsx from 'clsx';
import dayjs from 'dayjs';
import {
  Badge,
  Body,
  Caption,
  Grid
} from '@walmart-web/livingdesign-components';
import utc from 'dayjs/plugin/utc';
import relativeTime from 'dayjs/plugin/relativeTime';

import styles from './styles.module.css';
import { logger } from '../../../../../utils/logger';

dayjs.extend(utc);
dayjs.extend(relativeTime);

export type NotificationItemType = {
  id: string;
  title: string;
  type: string;
  message: string;
  date: string;
  isRead: boolean;
  webLink?: string;
};

type Props = NotificationItemType;

const getNotificationWebLink = (
  type: string,
  webLink: string,
  panelistId: string
) => {
  const url = new URL(webLink, window.location.origin);
  switch (type) {
    case 'activity':
      url.searchParams.append('panelist_hash', panelistId);
      return url.toString();
    default:
      return webLink;
  }
};

const getNotificationDate = (date?: string) => {
  if (!date) return '';

  const now = dayjs();
  const notificationDate = dayjs.utc(date).local();
  const diff = now.diff(notificationDate, 'day');
  if (diff < 1) {
    return notificationDate.fromNow();
  }
  return notificationDate.format('MM/DD/YYYY');
};

const NotificationItem: React.FC<Props> = ({
  id,
  title,
  type,
  message,
  date,
  isRead,
  webLink
}) => {
  const href =
    webLink &&
    getNotificationWebLink(
      type,
      webLink,
      localStorage.getItem('panelistId') || ''
    );

  const handleClick = () => {
    logger.clickStream('notification_item_click', {
      id,
      type: title,
      href: href || 'NA',
      panelistId: localStorage.getItem('panelistId') || ''
    });
  };

  return (
    <a
      className={styles.notificationLink}
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      onClick={handleClick}
    >
      <Grid UNSAFE_className={styles.notificationItem}>
        <Grid UNSAFE_className={styles.notificationContent}>
          <Body
            UNSAFE_className={clsx(styles.notificationTitle, {
              [styles.read]: isRead
            })}
            size="medium"
            weight={700}
          >
            {title}
          </Body>
          <Body size="small">{message}</Body>
          <Caption UNSAFE_className={styles.date}>
            {getNotificationDate(date)}
          </Caption>
        </Grid>
        {!isRead && (
          <Grid>
            <Badge aria-label="new badge" UNSAFE_className={styles.badge} />
          </Grid>
        )}
      </Grid>
    </a>
  );
};

export default NotificationItem;
